<div class="registration-page">
    <div class="teaser">
        <h2 i18n="@@landingpage.unknownextlogin.teaser.firstlogin" disable-empty format-text>Welcome to ClimatixIC</h2>
        <p>
            <span i18n="@@landingpage.unknownextlogin.teaser.text" disable-empty format-text>This seems to be your first time in ClimatixIC with this account. If you already have an account here, please click the "Log in" button below to log in with your account and assign this external account, so you can use it for future logins.</span>
            <span i18n="@@landingpage.unknownextlogin.teaser.signup.text" disable-empty format-text *ngIf="showSignup">If you are a new user with a supported device and want to sign up, please click the "Sign up" button below.</span>
        </p>
    </div>
    <form>
        <div class="button-row">
            <button class="default submit" (click)="login()" i18n="@@landingpage.unknownextlogin.button.login">Log in</button>
            <button class="default submit" (click)="register()" i18n="@@landingpage.unknownextlogin.button.signup" *ngIf="showSignup">Sign up</button>
            <button class="default submit" (click)="logOut()" i18n="@@landingpage.unknownextlogin.button.logout">Log out</button>
        </div>    
    </form>
</div>
